'use client';
import { Input, type InputProps as Props } from '@heroui/react';
import { useState } from 'react';
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export const PasswordInput = (props: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <Input
      radius='sm'
      {...props}
      autoComplete='current-password'
      endContent={
        <button className='focus:outline-none' type='button' onClick={toggleVisibility}>
          {isVisible ? (
            <FaEye className='text-2xl text-default-400 pointer-events-none' />
          ) : (
            <FaEyeSlash className='text-2xl text-default-400 pointer-events-none' />
          )}
        </button>
      }
      type={isVisible ? 'text' : 'password'}
    />
  );
};

export interface FormPasswordInputProps<T extends FieldValues> extends Props {
  name: Path<T>;
  control: Control<T, unknown>;
  transform?: (val: PathValue<T, Path<T>>) => T;
}

export const FormPasswordInput = <T extends FieldValues>({
  control,
  name,
  ...rest
}: FormPasswordInputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error, invalid, isDirty } }) => (
        <PasswordInput
          {...rest}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          isInvalid={isDirty && invalid}
          errorMessage={error?.message}
        />
      )}
    />
  );
};
